import { PlankPatternForm } from "./PlankPattern.form";

/** One tile photo is enough; the generator reads the tile's points and which way it faces. */
export const LongHexPatternForm = (props) => (
  <PlankPatternForm
    {...props}
    pattern="longhex"
    width={{ value: "20", min: 5, max: 60, labelKey: "TILE_WIDTH" }}
    height={{ value: "10", min: 3, max: 40, labelKey: "TILE_HEIGHT" }}
  />
);
